import { Http } from '@/lib/http';
export class InsuranceLoanWaiverService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/insurance-waivers/';
  }
  createInsuranceLoanWaiverSetting(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  getInsuranceLoanWaiverSettings() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  updateInsuranceLoanWaiverSetting(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}
